/* eslint-disable max-len, react/prop-types */
import React from 'react';

export const FacebookIcon = ({ className }) => (
	<svg
		className={className}
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="40" height="40" fill="#B53DFB" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.2031 30.5H21.6102V20.0585H24.4122C24.5526 20.0585 24.67 19.9516 24.6819 19.8129L24.9515 16.6621C24.9643 16.5048 24.8401 16.371 24.681 16.371H21.6102V14.1354C21.6102 13.6113 22.0398 13.1866 22.5698 13.1866H24.7295C24.8784 13.1866 25 13.0663 25 12.9191V9.76831C25 9.62028 24.8784 9.5 24.7295 9.5H21.0803C18.9393 9.5 17.2031 11.2159 17.2031 13.3338V16.371H15.2714C15.1216 16.371 15 16.4913 15 16.6393V19.7901C15 19.9382 15.1216 20.0585 15.2714 20.0585H17.2031V20.2258V30.5Z"
			fill="#F7F7F7"
		/>
	</svg>
);

export const WhatsappIcon = ({ className }) => (
	<svg
		className={className}
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="40" height="40" fill="#B53DFB" />
		<path
			d="M21.0059 8.83936C23.716 8.8394 26.2676 9.89948 28.1865 11.8179C30.1065 13.7373 31.1611 16.2888 31.1611 19.0024V19.0034C31.1551 24.6025 26.6023 29.1606 21 29.1606C19.1751 29.1606 17.3914 28.6701 15.8291 27.7427L15.8271 27.7417L15.7734 27.7095L12.5537 28.5552L11.5508 28.8188V27.6694L11.5791 27.5659L12.4287 24.4526L12.3945 24.3979V24.397C11.3779 22.7816 10.8399 20.9157 10.8398 18.9976V18.9966C10.8458 13.3972 15.3984 8.83936 21.0059 8.83936Z"
			stroke="#F7F7F7"
			strokeWidth="1.6"
			strokeMiterlimit="10"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.1051 20.954C26.287 21.0422 26.4082 21.1028 26.4634 21.191C26.5295 21.3012 26.5295 21.8192 26.309 22.431C26.094 23.0372 25.0521 23.5938 24.5505 23.671C24.104 23.7371 23.5361 23.7647 22.9077 23.5663C22.5273 23.445 22.0422 23.2852 21.4248 23.0152C18.9827 21.9625 17.3289 19.5927 17.0202 19.1463C16.9981 19.1133 16.9816 19.0912 16.9761 19.0802C16.8382 18.8928 15.9121 17.6583 15.9121 16.3852C15.9121 15.1838 16.502 14.5555 16.7721 14.2689C16.7886 14.2469 16.8052 14.2304 16.8217 14.2138C17.0587 13.9548 17.3454 13.8887 17.5163 13.8887C17.6872 13.8887 17.8636 13.8887 18.018 13.8997C18.0345 13.8997 18.0565 13.8997 18.0786 13.8997C18.2329 13.8997 18.4204 13.8997 18.6078 14.3461C18.6795 14.5169 18.7842 14.776 18.8945 15.046C19.1205 15.5916 19.3686 16.1923 19.4127 16.2805C19.4788 16.4128 19.5229 16.5616 19.4347 16.7379C19.4237 16.7655 19.4071 16.7875 19.3961 16.8096C19.33 16.9419 19.2804 17.0411 19.1701 17.1678C19.126 17.2174 19.0819 17.2725 19.0378 17.3276C18.9496 17.4379 18.8559 17.5481 18.7787 17.6252C18.6464 17.7575 18.5141 17.8953 18.6629 18.1543C18.8173 18.4133 19.3355 19.2676 20.1128 19.9565C20.9452 20.7005 21.6673 21.0146 22.0367 21.1744C22.1084 21.2075 22.169 21.2295 22.2076 21.2516C22.4667 21.3838 22.621 21.3618 22.7699 21.1854C22.9242 21.0091 23.4204 20.4249 23.5968 20.1659C23.7732 19.9069 23.9441 19.9509 24.1811 20.0336C24.4182 20.1218 25.7026 20.7501 25.9617 20.8823C26.0113 20.9099 26.061 20.9319 26.1051 20.954Z"
			fill="#F7F7F7"
		/>
	</svg>
);

export const MailIcon = ({ className }) => (
	<svg
		className={className}
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="40" height="40" fill="#B53DFB" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.3284 18.0068V24.4523C28.3284 25.352 27.9431 25.7794 27.1073 25.7794H12.9783C12.1425 25.7794 11.7572 25.352 11.7572 24.4523V18.0316L10 16.5673V24.906C10 26.3324 11.1464 27.5 12.5482 27.5H27.4518C28.8536 27.5 30 26.3324 30 24.906V16.6286L28.3284 18.0068ZM20.8388 19.5596C20.294 19.8751 19.724 19.8711 19.1452 19.548L13.1294 14.1621H26.9295L20.8388 19.5596ZM18.0154 21.0108C18.0587 21.0496 18.1044 21.0833 18.1541 21.113C18.7516 21.4723 19.387 21.6514 20.0165 21.6514C20.6465 21.6514 21.2711 21.4723 21.8464 21.113C21.8898 21.0863 21.9306 21.0561 21.969 21.0219L28.822 14.9496C28.8265 14.9451 28.8299 14.9396 28.8353 14.9356L29.6947 14.1938C29.3226 13.2045 28.4165 12.5 27.3588 12.5H12.6236C11.5861 12.5 10.6908 13.1763 10.3054 14.1364L11.496 15.1741L18.0154 21.0108Z"
			fill="#F7F7F7"
		/>
	</svg>
);

export const ShareIcon = ({ className }) => (
	<svg
		className={className}
		width="30"
		height="30"
		viewBox="0 0 30 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="30" height="30" fill="#B53DFB" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.3233 19.1872L12.4037 15.9218C12.4957 15.63 12.5455 15.3206 12.5455 15C12.5455 14.6793 12.4956 14.3697 12.4036 14.0777L18.323 10.8125C18.9213 11.4397 19.7774 11.8334 20.7273 11.8334C22.5323 11.8334 24 10.4131 24 8.66662C24 6.92029 22.5323 5.5 20.7273 5.5C18.9223 5.5 17.4546 6.92029 17.4546 8.66662C17.4546 8.9252 17.4875 9.17635 17.5482 9.41712L11.5482 12.7269C10.9588 12.1744 10.1564 11.8334 9.27269 11.8334C7.46786 11.8334 6 13.2535 6 15C6 16.7464 7.46786 18.1666 9.27269 18.1666C10.1566 18.1666 10.959 17.8255 11.5484 17.2728L17.5483 20.5825C17.4876 20.8234 17.4546 21.0746 17.4546 21.3334C17.4546 23.0797 18.9223 24.5 20.7273 24.5C22.5323 24.5 24 23.0797 24 21.3334C24 19.5869 22.5323 18.1666 20.7273 18.1666C19.7776 18.1666 18.9216 18.5602 18.3233 19.1872Z"
			fill="#F7F7F7"
		/>
	</svg>
);

export const ContentFacebookIcon = ({ className }) => (
	<svg
		className={className}
		xmlns="http://www.w3.org/2000/svg"
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
	>
		<rect width="40" height="40" rx="20" fill="#313131" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.2031 30.5H21.6102V20.0585H24.4122C24.5526 20.0585 24.67 19.9516 24.6819 19.8129L24.9515 16.6621C24.9643 16.5048 24.8401 16.371 24.681 16.371H21.6102V14.1354C21.6102 13.6113 22.0398 13.1866 22.5698 13.1866H24.7295C24.8784 13.1866 25 13.0663 25 12.9191V9.76831C25 9.62028 24.8784 9.5 24.7295 9.5H21.0803C18.9393 9.5 17.2031 11.2159 17.2031 13.3338V16.371H15.2714C15.1216 16.371 15 16.4913 15 16.6393V19.7901C15 19.9382 15.1216 20.0585 15.2714 20.0585H17.2031V20.2258V30.5Z"
			fill="#F7F7F7"
		/>
	</svg>
);

export const ContentWhatsappIcon = ({ className }) => (
	<svg
		className={className}
		xmlns="http://www.w3.org/2000/svg"
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
	>
		<rect width="40" height="40" rx="20" fill="#313131" />
		<path
			d="M21.0059 8.84082C23.716 8.84086 26.2676 9.90095 28.1865 11.8193C30.1065 13.7388 31.1611 16.2902 31.1611 19.0039V19.0049C31.1551 24.6039 26.6023 29.1621 21 29.1621C19.1751 29.1621 17.3914 28.6716 15.8291 27.7441L15.8271 27.7432L15.7734 27.7109L12.5537 28.5566L11.5508 28.8203V27.6709L11.5791 27.5674L12.4287 24.4541L12.3945 24.3994V24.3984C11.3779 22.7831 10.8399 20.9172 10.8398 18.999V18.998C10.8458 13.3987 15.3984 8.84082 21.0059 8.84082Z"
			stroke="#F7F7F7"
			strokeWidth="1.6"
			strokeMiterlimit="10"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.1051 20.9559C26.287 21.0441 26.4082 21.1047 26.4634 21.1929C26.5295 21.3031 26.5295 21.8212 26.309 22.4329C26.094 23.0392 25.0521 23.5958 24.5505 23.6729C24.104 23.7391 23.5361 23.7666 22.9077 23.5682C22.5273 23.447 22.0422 23.2872 21.4248 23.0171C18.9827 21.9645 17.3289 19.5947 17.0202 19.1483C16.9981 19.1152 16.9816 19.0932 16.9761 19.0821C16.8382 18.8948 15.9121 17.6603 15.9121 16.3872C15.9121 15.1857 16.502 14.5575 16.7721 14.2709C16.7886 14.2489 16.8052 14.2323 16.8217 14.2158C17.0587 13.9568 17.3454 13.8906 17.5163 13.8906C17.6872 13.8906 17.8636 13.8906 18.018 13.9016C18.0345 13.9016 18.0565 13.9016 18.0786 13.9016C18.2329 13.9016 18.4204 13.9016 18.6078 14.3481C18.6795 14.5189 18.7842 14.7779 18.8945 15.048C19.1205 15.5936 19.3686 16.1943 19.4127 16.2825C19.4788 16.4147 19.5229 16.5635 19.4347 16.7399C19.4237 16.7675 19.4071 16.7895 19.3961 16.8115C19.33 16.9438 19.2804 17.043 19.1701 17.1698C19.126 17.2194 19.0819 17.2745 19.0378 17.3296C18.9496 17.4398 18.8559 17.55 18.7787 17.6272C18.6464 17.7595 18.5141 17.8972 18.6629 18.1563C18.8173 18.4153 19.3355 19.2695 20.1128 19.9584C20.9452 20.7024 21.6673 21.0166 22.0367 21.1764C22.1084 21.2094 22.169 21.2315 22.2076 21.2535C22.4667 21.3858 22.621 21.3638 22.7699 21.1874C22.9242 21.011 23.4204 20.4269 23.5968 20.1678C23.7732 19.9088 23.9441 19.9529 24.1811 20.0356C24.4182 20.1237 25.7026 20.752 25.9617 20.8843C26.0113 20.9118 26.061 20.9339 26.1051 20.9559Z"
			fill="#F7F7F7"
		/>
	</svg>
);

export const ContentMailIcon = ({ className }) => (
	<svg
		className={className}
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="40" height="40" rx="20" fill="#313131" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.3284 18.0068V24.4523C28.3284 25.352 27.9431 25.7794 27.1073 25.7794H12.9783C12.1425 25.7794 11.7572 25.352 11.7572 24.4523V18.0316L10 16.5673V24.906C10 26.3324 11.1464 27.5 12.5482 27.5H27.4518C28.8536 27.5 30 26.3324 30 24.906V16.6286L28.3284 18.0068ZM20.8388 19.5596C20.294 19.8751 19.724 19.8711 19.1452 19.548L13.1294 14.1621H26.9295L20.8388 19.5596ZM18.0154 21.0108C18.0587 21.0496 18.1044 21.0833 18.1541 21.113C18.7516 21.4723 19.387 21.6514 20.0165 21.6514C20.6465 21.6514 21.2711 21.4723 21.8464 21.113C21.8898 21.0863 21.9306 21.0561 21.969 21.0219L28.822 14.9496C28.8265 14.9451 28.8299 14.9396 28.8353 14.9356L29.6947 14.1938C29.3226 13.2045 28.4165 12.5 27.3588 12.5H12.6236C11.5861 12.5 10.6908 13.1763 10.3054 14.1364L11.496 15.1741L18.0154 21.0108Z"
			fill="white"
		/>
	</svg>
);

export const InstaIcon = ({ className }) => (
	<svg
		className={className}
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="40" height="40" rx="20" fill="#313131" />
		<g clipPath="url(#clip0_85_47534)">
			<path
				d="M23.879 30H16.1262C12.7509 30 10.0039 27.253 10.0039 23.8777V16.1249C10.0013 12.747 12.7483 10 16.1236 10H23.8764C27.2517 10 29.9987 12.747 29.9987 16.1223V23.8751C29.9987 27.2504 27.2517 29.9974 23.8764 29.9974L23.879 30ZM16.1236 11.4981C13.5739 11.4981 11.4968 13.5726 11.4968 16.1249V23.8777C11.4968 26.4274 13.5713 28.5045 16.1236 28.5045H23.8764C26.4261 28.5045 28.5032 26.43 28.5032 23.8777V16.1249C28.5032 13.5752 26.4287 11.4981 23.8764 11.4981H16.1236Z"
				fill="#F7F7F7"
			/>
			<path
				d="M19.9992 25.0609C17.2107 25.0609 14.9414 22.7916 14.9414 20.0031C14.9414 17.2146 17.2107 14.9453 19.9992 14.9453C22.7877 14.9453 25.0569 17.2146 25.0569 20.0031C25.0569 22.7916 22.7877 25.0609 19.9992 25.0609ZM19.9992 16.4772C18.0545 16.4772 16.4733 18.0584 16.4733 20.0031C16.4733 21.9478 18.0545 23.529 19.9992 23.529C21.9439 23.529 23.5251 21.9478 23.5251 20.0031C23.5251 18.0584 21.9439 16.4772 19.9992 16.4772Z"
				fill="#F7F7F7"
			/>
			<path
				d="M26.926 14.3906C26.926 15.1176 26.3366 15.707 25.6096 15.707C24.8826 15.707 24.2932 15.1176 24.2932 14.3906C24.2932 13.6636 24.8826 13.0742 25.6096 13.0742C26.3366 13.0742 26.926 13.6636 26.926 14.3906Z"
				fill="#F7F7F7"
			/>
		</g>
		<defs>
			<clipPath id="clip0_85_47534">
				<rect width="20" height="20" fill="white" transform="translate(10 10)" />
			</clipPath>
		</defs>
	</svg>
);
